module.exports = __webpack_public_path__ + "img/item_Story_22.25240eee.jpeg";